// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuratypesComponent } from './AuratypesComponent';
import {
  AuratypesComponentFromJSON,
  AuratypesComponentFromJSONTyped,
  AuratypesComponentToJSON,
  AuratypesComponentToJSONTyped,
} from './AuratypesComponent';

/**
 *
 * @export
 * @interface ResponseEnvironmentSpecComponent
 */
export interface ResponseEnvironmentSpecComponent {
  /**
   *
   * @type {AuratypesComponent}
   * @memberof ResponseEnvironmentSpecComponent
   */
  component?: AuratypesComponent;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpecComponent
   */
  createdAt?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseEnvironmentSpecComponent
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpecComponent
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpecComponent
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseEnvironmentSpecComponent interface.
 */
export function instanceOfResponseEnvironmentSpecComponent(
  value: object,
): value is ResponseEnvironmentSpecComponent {
  return true;
}

export function ResponseEnvironmentSpecComponentFromJSON(
  json: any,
): ResponseEnvironmentSpecComponent {
  return ResponseEnvironmentSpecComponentFromJSONTyped(json, false);
}

export function ResponseEnvironmentSpecComponentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentSpecComponent {
  if (json == null) {
    return json;
  }
  return {
    component:
      json['component'] == null
        ? undefined
        : AuratypesComponentFromJSON(json['component']),
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function ResponseEnvironmentSpecComponentToJSON(
  json: any,
): ResponseEnvironmentSpecComponent {
  return ResponseEnvironmentSpecComponentToJSONTyped(json, false);
}

export function ResponseEnvironmentSpecComponentToJSONTyped(
  value?: ResponseEnvironmentSpecComponent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    component: AuratypesComponentToJSON(value['component']),
    created_at: value['createdAt'],
    id: value['id'],
    name: value['name'],
    updated_at: value['updatedAt'],
  };
}
